<script>
    import f9tabs from "shared/Components/f9tabs.vue";
    import f9tab from "shared/Components/f9tab.vue";
    import BagPriceExisting from "./BagPriceExisting.vue";
    import BagPriceNew from "./BagPriceNew.vue";

    export default {
        props: {
            searching: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            search(existing, params) {
                this.$emit("search", {
                    existing,
                    params
                })
            }
        },
        components: {
            f9tabs,
            f9tab,
            BagPriceExisting,
            BagPriceNew
        }
    }
</script>

<template>
    <div class="bag-price-widget">
        <f9tabs @tabChanged="$emit('tabChanged', $event)">
            <f9tab name="Bag Prices for Existing Trip">
                <bag-price-existing :done-searching="!searching" @search="search(true, $event)"></bag-price-existing>
            </f9tab>
            <f9tab name="Bag Prices for New Trip">
                <bag-price-new :done-searching="!searching" @search="search(false, $event)"></bag-price-new>
            </f9tab>
        </f9tabs>
    </div>
</template>

<style lang="less" scoped>
    @import "~less-variables";

    .bag-price-widget {
        width: 712px;
    }

    @media @tablet-lg {
        .bag-price-widget {
            width: calc(~"100vw - 60px");
        }
    }

    @media @tablet {
        .bag-price-widget {
            width: calc(~"100vw - 30px");
        }
    }
</style>
